<script setup lang="ts">
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination } from 'swiper/modules';
import VueEasyLightbox from 'vue-easy-lightbox';
import { ref } from 'vue';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import styles from '@/assets/sass/components/ship-detail.module.scss';

interface Props {
    shipName: string,
    shipCode: string,
    images: string[],
};

const props = defineProps<Props>();

// --- State for the Lightbox ---
const lightboxVisible = ref(false);
const lightboxIndex = ref(0);

// --- Methods to control the Lightbox ---

/**
 * Opens the lightbox at a specific image index.
 * @param {number} index - The index of the image to show.
 */
const showLightbox = (index: number) => {
    lightboxIndex.value = index;
    lightboxVisible.value = true;
};

/**
 * Hides the lightbox.
 */
const hideLightbox = () => {
    lightboxVisible.value = false;
};

// --- Swiper Modules ---
const swiperModules = [Navigation, Pagination];
</script>
<template>
    <div :class="styles['ship-detail']">
        <h2 :class="styles['ship-detail__heading']">
            {{ $t('LABELS.travel-on-ship') }} <RouterLink v-if="shipCode" :to="{
                name: 'cruiserPage', params: {
                    shipCode,
                }
            }"> {{ shipName }} </RouterLink>
        </h2>
        <div :class="styles['ship-detail__swiper-wrapper']">
            <Swiper :class="styles['ship-detail__swiper']" :modules="swiperModules" :slides-per-view="1"
                :navigation="true" :pagination="{ clickable: true }">
                <SwiperSlide v-for="(image, index) in images" :key="index" @click="showLightbox(index)"
                    style="cursor: pointer;">
                    <img :src="image" :alt="`${shipName} image ${index + 1}`"
                        :class="styles['ship-detail__swiper-img']" />
                </SwiperSlide>
            </Swiper>
        </div>
        <VueEasyLightbox :visible="lightboxVisible" :imgs="images" :index="lightboxIndex" :move-disabled="true"
            :zoom-disabled="true" @hide="hideLightbox" />
    </div>
</template>
